import { useEffect, useState } from 'react';
// import { ShopContext } from '../context/ShopContext';
import Title from './Title';
import ProductItem from './ProductItem';
import axiosInstance from '../api/axiosInstance';

const ProductCollection = ({ campaignCategoryList }) => {
  const [campaignList, setCampaignList] = useState([]);
  const [activeCategory, setActiveCategory] = useState('all');
  const [loading, setLoading] = useState(false);

  const fetchCampaigns = async (categoryId) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get('/home', {
        params: {
          category_id: categoryId !== 'all' ? categoryId : undefined,
        },
      });

      setCampaignList(response.data.campaign_list || []);
    } catch (error) {
      console.error('Error fetching campaigns:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryChange = (categoryId) => {
    setActiveCategory(categoryId);
    fetchCampaigns(categoryId);
  };

  useEffect(() => {
    fetchCampaigns('all');
  }, []);

  return (
    <div className='product-collection'>
      <div className="container">
        <div className="title-section heading text-center">
          <Title text1={'Causes you can support'} />
          <p>Create sustained impact. Support verified projects. Get regular updates. Save tax. Cancel anytime.</p>
        </div>

        {/* Category Filter Tabs */}
        <div className="category-filter text-center our_campaigns">
          <button
            className={`btn ${activeCategory === 'all' ? 'button-active-filter' : 'common-filter-button'}`}
            onClick={() => handleCategoryChange('all')}
          >
            All
          </button>

          {campaignCategoryList.map((category) => (
            <button
              key={category.id}
              className={`btn ${activeCategory === category.id ? 'button-active-filter' : 'common-filter-button'}`}
              onClick={() => handleCategoryChange(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>

        <div className="product-collection-section mt-4">
          {loading ? (
            <div className="row">
              {[...Array(6)].map((_, i) => (
                <div className="col-md-4 mb-4" key={i}>
                  <div className="campaign-skeleton skeleton-box"></div>
                </div>
              ))}
            </div>
          ) : campaignList.length === 0 ? (
            <div className="text-center my-5 w-100" key={1}>
              <img
                src="/images/empty-state.png"
                alt="No campaigns"
                style={{ maxWidth: '200px', marginBottom: '20px' }}
              />
              <h5>No campaigns found in this category</h5>
              <p>Try selecting a different category or check back later.</p>
            </div>
          ) : (
            <div className="row">
              {campaignList.map((capaingn) => (
                <ProductItem
                  key={capaingn.id}
                  id={capaingn.id}
                  slug={capaingn.slug}
                  thumbnail_image={capaingn.thumbnail_imge}
                  name={capaingn.name}
                  description={capaingn.hoursLeft}
                  raise_amount={capaingn.raise_amount}
                  end_date={capaingn.end_date}
                  campaing_type={capaingn.campaing_type}
                  order_detail_count={capaingn.order_detail_count}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCollection;
